var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-list"},_vm._l((_vm.colors),function(color){return _c('div',{key:color,staticClass:"color-list__item",style:({
            backgroundColor: color,
            borderColor: _vm.selectedColor === color ? 'black' : 'transparent',
        }),on:{"click":function($event){return _vm.handleColorClick(color)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }